export default function concatArrays(...arrays: any[]): any[] {
  return [].concat(...arrays);
}
